<h2 mat-dialog-title><mat-icon>bookmark_border</mat-icon> Фильтры по умолчанию</h2>
<mat-dialog-content>
  <p class="intro">При открытии заказов и нажатии «Сбросить». Сохраняются в вашем аккаунте на всех компьютерах.</p>
  <div class="presets" aria-label="Набор фильтров">
    <button type="button" mat-stroked-button class="cashier" [class.selected]="preset === 'cashier'"
      [attr.aria-pressed]="preset === 'cashier'" [disabled]="saving" (click)="selectPreset('cashier')">
      <mat-icon>point_of_sale</mat-icon><span><strong>Касса</strong><small>Только склад</small></span>
    </button>
    <button type="button" mat-stroked-button class="manager" [class.selected]="preset === 'manager'"
      [attr.aria-pressed]="preset === 'manager'" [disabled]="saving" (click)="selectPreset('manager')">
      <mat-icon>person_outline</mat-icon><span><strong>Менеджер</strong><small>Только мои</small></span>
    </button>
    <button type="button" mat-stroked-button [class.selected]="preset === 'current'"
      [attr.aria-pressed]="preset === 'current'" [disabled]="saving" (click)="selectPreset('current')">
      <mat-icon>tune</mat-icon><span><strong>Текущие</strong><small>Мой набор</small></span>
    </button>
  </div>
  <div class="scope">
    <mat-slide-toggle [checked]="draft.manager === 'me'" [disabled]="saving"
      (change)="draft.manager = $event.checked ? 'me' : 'all'">Только мои заказы</mat-slide-toggle>
    <div class="warehouse">
      <app-warehouse-selector [control]="warehouseControl"></app-warehouse-selector>
      <button *ngIf="warehouseControl.value" type="button" mat-icon-button [disabled]="saving"
        aria-label="Все склады" (click)="warehouseControl.setValue(null)"><mat-icon>close</mat-icon></button>
    </div>
    <div *ngIf="!validWarehouse" class="fieldHint">Выберите склад из списка.</div>
  </div>
  <div class="preview" aria-live="polite">
    <span class="previewTitle">Будут показаны</span>
    <strong>{{ managerLabel }} · {{ warehouseControl.value?.description || 'Все склады' }}</strong>
    <div *ngIf="statusLabels.length" class="statuses"><span *ngFor="let label of statusLabels">{{ label }}</span></div>
    <span *ngIf="!statusLabels.length">Любые статусы</span>
  </div>
  <p class="hint">Поисковый текст, период, клиент и ID заказа не сохраняются. Поиск кассы по телефону или ID остаётся глобальным.</p>
  <p *ngIf="error" class="error" role="alert">{{ error }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button *ngIf="data.user.orderListDefaults" class="remove" type="button" mat-button [disabled]="saving" (click)="save(true)">Убрать настройку</button>
  <button type="button" mat-button mat-dialog-close [disabled]="saving">Отмена</button>
  <button type="button" mat-flat-button color="primary" [disabled]="saving || !validWarehouse" (click)="save()">
    <mat-icon>{{ saving ? 'hourglass_empty' : 'done' }}</mat-icon> Сохранить и применить
  </button>
</mat-dialog-actions>
